import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {CustomFieldModel} from "../../models/custom-field.model";
import {SettingsService} from "../../services/settings-service.service";

export class CustomFieldsSelectComponent implements IController{

  name?: string // field name
  selectedId: any;
  options: CustomFieldModel[];
  isRequired: boolean;
  ngPlaceholder: any;
  noUnderline: any;
  onChange: Function;

  public selectedModel: CustomFieldModel;
  public searchTerm: string;

  constructor(private $mdSelect, private settingsService: SettingsService) {
  }


  $onInit() {
    this.searchTerm = '';

    if (!this.options) {
      this._getOptions();
    }

    if (!this.name) {
      this.name = 'customField';
    }

    if (this.selectedId) {
      this.selectedModel = _.find(this.options, (o: CustomFieldModel) => {
        return o.id === this.selectedId;
      })
    }
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this.selectedModel = _.find(this.options, (o: CustomFieldModel) => {
        return o.id === this.selectedId;
      })
    }
    if (changes.options && !changes.options.isFirstChange()) {
      if (!this.options) {
        this.options = [];
      }
      this.selectedModel = _.find(this.options, (o: CustomFieldModel) => {
        return o.id === this.selectedId;
      })
    }
  };

  onClose() {
    this.searchTerm = '';
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.selectedModel = undefined
  }

  select(customField) {
    this.selectedModel = customField;
    this.onChange({customField: customField});
    this.$mdSelect.hide();
  }

  private _getOptions() {
    this.options = [];
    this.settingsService.getPackageFields()
      .then((options: CustomFieldModel[]) => {
        this.options = options;
        this.selectedModel = _.find(options, (o: CustomFieldModel) => {
          return o.id === this.selectedId;
        })
      })
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('customFieldsSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      name: '@?',
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./custom-fields-select.html').default,
    controller: CustomFieldsSelectComponent
  });
